{
    "DependsOnItem": {
        "type": "object",
        "properties": {
            "from": {
                "type": "object",
                "properties": {
                    "namespace": {
                        "type": "string"
                    },
                    "id": {
                        "type": "string"
                    },
                    "reference": {
                        "type": "string"
                    }
                },
                "required": [
                    "namespace",
                    "id"
                ],
                "additionalProperties": false
            },
            "to": {
                "type": "object",
                "properties": {
                    "fragmentType": {
                        "type": "string"
                    },
                    "fragmentInstance": {
                        "type": "string"
                    },
                    "dependedById": {
                        "type": "string"
                    }
                },
                "required": [
                    "fragmentType",
                    "fragmentInstance",
                    "dependedById"
                ],
                "additionalProperties": false
            }
        },
        "required": [
            "from",
            "to"
        ],
        "isTopLevelDataNode": true,
        "additionalProperties": false
    }
}
